<template>
  <div style="width:100%;height:100%;background-color: #fff;">
    <div class="download" v-if="status==0">
      <div class="download-content">
        <div class="download-wrapper">
          <img style="width:1.995rem;vertical-align: middle;" src="/static/img/logo.png" />
          <div class="download-item">
            <div>{{$t('system.Name')}}</div>
            <div>{{$t('system.Company')}}</div>
            <div>
              <span>{{$t('system_download_download_banbenhao')}}</span>
              <span>{{$t('system_download_download_daxiao')}}</span></div>
          </div>
        </div>
        <a v-if="!isWeiXin() && isAndroid()&&versionlist" target="_blank" :href="versionlist.isAndroid.url">
          <div class="downloadBtn" @click="download">{{$t('system.DownloadInstall')}}</div>
        </a>
        <a v-if="!isWeiXin() && isiOS()&&versionlist" target="_blank" :href="versionlist.isiOS.url">
          <div class="downloadBtn" @click="download">{{$t('system.DownloadInstall')}}</div>
        </a>
        <div v-if="isWeiXin()" class="downloadBtn" @click="download">{{$t('system.DownloadInstall')}}</div>
        <div class="download-introduce">
          <div class="download-introduceTitle">
            <div class="border_bottom" style="width:1.25rem;background-color: #e3e3e3;"></div>
            <div>{{$t('system.Name')}}<span>{{$t('system_download_download_jieshao')}}</span></div>
            <div class="border_bottom" style="width:1.25rem;background-color: #e3e3e3;"></div>
          </div>
          <div class="download-introduceWrapper">
            <div class="download-introduceWrapper-title">
              <div>
                <div style="border:0.01rem dashed #e3e3e3;width:100%"></div>
              </div>
              <div>{{$t('system_download_download_yingyongjieshao')}}</div>
            </div>
            <div class="download-introduceWrapper-item">
              <div>{{$t('system.Name')}}<span>{{$t('system_download_download_slcglqxdqyslglxtykqd')}}</span></div>
              <div><span>{{$t('system_download_download_yonghukeyitongguo')}}</span>{{$t('system.Name')}}<span>{{$t('system_download_download_xtksdjhjpjdhcpdcxyds')}}</span></div>
            </div>
            <div class="download-introduceWrapper-title">
              <div>
                <div style="border:0.01rem dashed #e3e3e3;width:100%"></div>
              </div>
              <div>{{$t('system_download_download_zhuyaogongneng')}}</div>
            </div>
            <div class="download-introduceWrapper-item">
              <div>{{$t('system_download_download_àcsrqqfsjdxxcxbydjpj')}}</div>
              <div>{{$t('system_download_download_qyyjdpwxygdkjkdphsxy')}}</div>
              <div>{{$t('system_download_download_qingsongchakanguanlidingdanyijiantuipiaogaiqian')}}</div>
              <div>{{$t('system_download_download_zcqydcbgkszydgczlhgk')}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="downloadPrompt" style="padding-top:1rem" v-if="status==1">
      <div class="downloadPrompt-tips">
        <span class="triangle_border_up"></span>
        <span>
          <div>{{$t('system.TopRightCorner')}}</div>
          <div>{{$t('system.BrowserOpen')}}</div>
        </span>
      </div>
      <div class="downloadPrompt-content">
        <img style="width:1.596rem;" src="/static/img/logo.png" />
        <div style="padding:0.133rem 0">
          <img v-if="isAndroid()" style="width:0.665rem;vertical-align: middle" src="/static/img/android.png" />
          <img v-if="isiOS()" style="width:0.665rem;vertical-align: middle" src="/static/img/ios.png" />
          <span style="color:#333;font-size:0.452rem;vertical-align: sub">{{$t('system.Name')}}</span>
        </div>
        <div>{{$t('system.CannotDownloaded')}}</div>
      </div>
    </div>
  </div>
</template>
<style scoped>
  .download,
  .download-content {
    width: 100%;
    height: 100%;
    background-color: rgb(255, 255, 255);
  }

  .download a {
    text-decoration: none;
  }

  .download-wrapper {
    /* width:5.320rem;
    text-align: center;
    margin: 0 auto;
    font-size: 0.372rem;
    color: #12a3ff; */
    padding: 1.064rem 0.399rem 0 0.399rem
  }

  .download-item {
    padding-left: 0.399rem;
    font-size: 0.3192rem;
    color: #999;
    display: inline-block;
    vertical-align: middle;
  }

  .download-item>div:first-child {
    font-size: 0.425rem;
    color: #030303;
    padding-bottom: 0.266rem;
  }

  .download-item>div:nth-child(2) {
    padding-bottom: 0.266rem
  }

  .downloadBtn {
    width: 2.660rem;
    margin: 0.532rem auto 0.665rem auto;
    height: 0.798rem;
    line-height: 0.798rem;
    text-align: center;
    background-color: #12a3ff;
    color: #fff;
    border-radius: 0.106rem;
    font-size: 0.3192rem;
  }

  .downloadPrompt-content {
    width:5.320rem;
    text-align: center;
    margin: 2.660rem auto 0 auto;
    font-size: 0.372rem;
    color: #12a3ff;
  }

  .downloadPrompt-tips {
    width: 2.660rem;
    text-align: center;
    margin-top: 0.399rem;
    font-size: 0.3192rem;
    background-color: #12a3ff;
    color: #fff;
    border-radius: 0.266rem;
    padding: 0.133rem 0.266rem;
    position: absolute;
    right: 0.266rem;
    top: 0;
  }

  .triangle_border_up {
    width: 0;
    height: 0;
    border-width: 0 0.133rem 0.266rem;
    border-style: solid;
    border-color: transparent transparent #12a3ff;
    position: absolute;
    top: -0.266rem;
    right: 0.266rem;
  }

  .download-introduceTitle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: #323232;
    font-size: 0.372rem;
  }
  .download-introduceWrapper{
    background-color: #fff;
  }

  .download-introduceWrapper-title {
    position: relative;
    font-size: 0.372rem;
  }

  .download-introduceWrapper-title>div {
    height: 0.798rem;
    line-height: 0.798rem;
  }

  .download-introduceWrapper-title>div:first-child {
    margin-left: 2.261rem;
    display: flex;
    align-items: center;
    justify-content: space-between;

  }

  .download-introduceWrapper-title>div:nth-child(2) {
    position: absolute;
    top: 0;
    left: 0;
    width: 1.995rem;
    text-align: right;
    padding-right: 0.266rem;
    height: 0.798rem;
    line-height: 0.798rem;
  }

  .download-introduceWrapper-item {
    font-size: 0.372rem;
    color: #999;
    padding: 0 0.399rem 0.399rem 0.399rem;
  }

</style>
<script>
  export default {
    data() {
      return {
        status: 0,
        versionlist:{}
      }
    },
    created() {
      let __self = this;
      __self.$api.base.gettripcomVersion({}).then(json => {
        if (json.isSucc) {
          __self.versionlist = json.result;
        }
      })
    },
    mounted() {
      let __self = this;
      if (__self.isWeiXin()) {
        if (__self.isiOS()) {
          location.href =__self.versionlist.isiOS.url;
        }
        if (__self.isAndroid()) {
          __self.status = 1;
        }
      } else {
        if (__self.isiOS()) {
          location.href =__self.versionlist.isiOS.url;
        }
      }
    },
    methods: {
      download() {
        let __self = this;
        if (__self.isWeiXin() && __self.isiOS()) {
          location.href = __self.versionlist.isiOS.url;
        }
      },
      isWeiXin() {
        let __self = this;
        let userAgent = window.navigator.userAgent;
        if (userAgent.toLowerCase().match(/MicroMessenger/i) == 'micromessenger') {
          return true;
        } else {
          return false;
        }
      },
      isAndroid() {
        let userAgent = window.navigator.userAgent;
        if (userAgent.indexOf('Android') > -1 || userAgent.indexOf('Adr') > -1) {
          return true;
        } else {
          return false;
        }
      },
      isiOS() {
        let userAgent = window.navigator.userAgent;
        if (userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
          return true;
        } else {
          return false;
        }
      }
    },
  }

</script>
